import React, { Component } from 'react';

function encode(data) {
	return Object.keys(data)
		.map((key) => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
		.join('&');
}

export default class Contact extends Component {
	constructor(props) {
		super(props);
		this.state = { name: '', email: '', message: '' };
	}

        clearFields(event) {
                this.setState({ name: '', email: '', message: '' });
                Array.from(event.target).forEach((e) => (e.value = ''));
        }

	handleSubmit = (e) => {
		e.preventDefault();
		fetch('/', {
			method: 'POST',
			headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
			body: encode({ 'form-name': 'contact', ...this.state }),
		})
			.then(() => this.clearFields(e))
			.then(() => alert('Message sent!'))
			.catch((error) => alert(error));
	};

	handleChange = (e) => this.setState({ [e.target.name]: e.target.value });

	render() {
		return (
                        <section id="contact" className="relative bg-black text-silver">
                                <div className="container px-5 py-10 mx-auto flex sm:flex-nowrap flex-wrap">
                                        <div className="lg:w-2/3 md:w-1/2 bg-black rounded-lg overflow-hidden sm:mr-10 p-10 flex items-end justify-start relative">
						<iframe
							width="100%"
							height="100%"
							title="map"
							className="absolute inset-0"
							frameBorder={0}
							marginHeight={0}
							marginWidth={0}
							style={{ filter: 'opacity(0.7)' }}
							src="https://www.google.com/maps/embed/v1/place?q=Brooklyn&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8"
						/>
                                                <div className="bg-red-700 relative flex flex-wrap py-6 rounded shadow-md">
                                                        <div className="lg:w-3/4 px-6">
                                                                <h2 className="title-font font-semibold text-white tracking-widest text-xs">
                                                                        ADDRESS
                                                                </h2>
                                                                <p className="mt-1 text-white">Brooklyn, NY</p>
                                                        </div>
                                                        <div className="lg:w-1/2 px-6 mt-4 lg:mt-0">
                                                                <h2 className="title-font font-semibold text-white tracking-widest text-xs">
                                                                        EMAIL
                                                                </h2>
                                                                <a href="mailto:cdelancy11@gmail.com" className="text-white leading-relaxed">
                                                                        cdelancy11@gmail.com
                                                                </a>
                                                                <h2 className="title-font font-semibold text-white tracking-widest text-xs mt-4">
                                                                        PHONE
                                                                </h2>
                                                                <p className="leading-relaxed text-white">347-622-0063</p>
                                                        </div>
                                                </div>
                                        </div>
					<form
						netlify
						name="contact"
						onSubmit={this.handleSubmit}
                                                className="lg:w-1/3 md:w-1/2 flex flex-col md:ml-auto w-full md:py-8 mt-8 md:mt-0"
					>
						<h2 className="text-white sm:text-4xl text-3xl mb-1 font-medium title-font">
							Contact Me
						</h2>
                                                <p className="leading-relaxed mb-5">
                                                        If you have any inquiries for me or would just like to chat, reach
                                                        out!
                                                </p>
						<div className="relative mb-4">
							<input type="hidden" name="form-name" value="contact" />
                                                        <label htmlFor="name" className="leading-7 text-sm text-silver">
                                                                Name
                                                        </label>
                                                        <input
                                                                type="text"
                                                                id="name"
                                                                name="name"
                                                                className="w-full bg-black rounded border border-silver focus:border-red-700 focus:ring-2 focus:ring-red-500 text-base outline-none text-white py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
                                                                onChange={this.handleChange}
                                                        />
                                                </div>
                                                <div className="relative mb-4">
                                                        <label
                                                                htmlFor="email"
                                                                className="leading-7 text-sm text-silver"
                                                        >
                                                                Email
                                                        </label>
                                                        <input
                                                                type="email"
                                                                id="email"
                                                                name="email"
                                                                className="w-full bg-black rounded border border-silver focus:border-red-700 focus:ring-2 focus:ring-red-500 text-base outline-none text-white py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
                                                                onChange={this.handleChange}
                                                        />
                                                </div>
                                                <div className="relative mb-4">
                                                        <label
                                                                htmlFor="message"
                                                                className="leading-7 text-sm text-silver"
                                                        >
                                                                Message
                                                        </label>
                                                        <textarea
                                                                id="message"
                                                                name="message"
                                                                className="w-full bg-black rounded border border-silver focus:border-red-700 focus:ring-2 focus:ring-red-500 h-32 text-base outline-none text-white py-1 px-3 resize-none leading-6 transition-colors duration-200 ease-in-out"
                                                                onChange={this.handleChange}
                                                        />
                                                </div>
                                                <button
                                                        type="submit"
                                                        className="text-white bg-red-700 border-0 py-2 px-6 focus:outline-none hover:bg-red-600 rounded text-lg"
                                                >
                                                        Submit
                                                </button>
                                        </form>
				</div>
			</section>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Contact.js